import { Users, Award, MessageSquare, PhoneCall } from "lucide-react";

const guarantees = [
  {
    icon: Users,
    title: "Direct Involvement During the Whole Service Process",
    desc: "Personal and direct involvement in all aspects of the company's operations and service",
  },
  {
    icon: Award,
    title: "Strong Focus on Consistent Quality & Excellence",
    desc: "Ensuring to maintain excellence, quality, customer satisfaction & continuous improvement",
  },
  {
    icon: MessageSquare,
    title: "Clear, Concise & Continuous Client Communication",
    desc: "On-going contact with clients to ensure their needs are understood & fulfilled",
  },
  {
    icon: PhoneCall,
    title: "Direct Contact to our Staff & Management during Services",
    desc: "Direct availability, with management readily contactable & accessible to clients.",
  },
];

const ACGGuarantee = () => {
  return (
    <section className="py-16 px-4 bg-muted">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl font-bold text-foreground mb-2">The ACG Guarantee</h2>
        <p className="text-muted-foreground mb-10 max-w-2xl mx-auto">
          We are committed to outstanding levels of quality & consistency. Given the company's size and structure, quality is assured throughout.{" "}
          <a href="/contact-us" className="text-primary hover:underline font-medium">
            Contact our team to discuss your project
          </a>.
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {guarantees.map((g) => (
            <div key={g.title} className="bg-background p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <g.icon className="w-10 h-10 text-primary mx-auto mb-4" />
              <h3 className="text-sm font-bold text-foreground mb-2">{g.title}</h3>
              <p className="text-xs text-muted-foreground">{g.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ACGGuarantee;
